export default class RequestCancelled extends Error {
    constructor(message = "Request was cancelled") {
        super(message);
        this.name = "RequestCancelled";
        this.code = "ECANCELLED";
        this.isCancelled = true;
    }
}
